module.exports = __webpack_public_path__ + "assets/img/27_1246.1d630939.jpg";